import { ICON_TYPES } from '../constants';

export const RefrigeratorIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.875 7C7.62708 7 7.41942 6.91629 7.252 6.74887C7.084 6.58087 7 6.37292 7 6.125V5.25C7 5.00208 7.084 4.79413 7.252 4.62613C7.41942 4.45871 7.62708 4.375 7.875 4.375C8.12292 4.375 8.33088 4.45871 8.49888 4.62613C8.66629 4.79413 8.75 5.00208 8.75 5.25V6.125C8.75 6.37292 8.66629 6.58087 8.49888 6.74887C8.33088 6.91629 8.12292 7 7.875 7ZM7.875 14.875C7.62708 14.875 7.41942 14.791 7.252 14.623C7.084 14.4556 7 14.2479 7 14V11.375C7 11.1271 7.084 10.9191 7.252 10.7511C7.41942 10.5837 7.62708 10.5 7.875 10.5C8.12292 10.5 8.33088 10.5837 8.49888 10.7511C8.66629 10.9191 8.75 11.1271 8.75 11.375V14C8.75 14.2479 8.66629 14.4556 8.49888 14.623C8.33088 14.791 8.12292 14.875 7.875 14.875ZM5.25 19.25C4.76875 19.25 4.35692 19.0788 4.0145 18.7364C3.6715 18.3934 3.5 17.9813 3.5 17.5V3.5C3.5 3.01875 3.6715 2.60662 4.0145 2.26362C4.35692 1.92121 4.76875 1.75 5.25 1.75H15.75C16.2312 1.75 16.6434 1.92121 16.9864 2.26362C17.3288 2.60662 17.5 3.01875 17.5 3.5V17.5C17.5 17.9813 17.3288 18.3934 16.9864 18.7364C16.6434 19.0788 16.2312 19.25 15.75 19.25H5.25ZM5.25 17.5H15.75V9.625H5.25V17.5ZM5.25 7.875H15.75V3.5H5.25V7.875Z"
        fill="#43494F"
      />
    </svg>
  );
};

RefrigeratorIcon.iconType = ICON_TYPES.REFRIGERATOR;
